import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { ImSpinner2 } from "react-icons/im";
import { cn } from "../../lib/utils";
import { buttonVariants } from "./constants";
import { ButtonProps } from "./types";

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      fullWidth,
      asChild = false,
      icon,
      iconPosition = "left",
      isLoading,
      children,
      disabled,
      ...props
    },
    ref
  ) => {
    if (asChild) {
      return (
        <Slot
          className={cn(
            buttonVariants({ variant, size, fullWidth, className })
          )}
          ref={ref}
          {...props}
        >
          {children}
        </Slot>
      );
    }

    return (
      <button
        className={cn(buttonVariants({ variant, size, fullWidth, className }))}
        ref={ref}
        disabled={disabled || isLoading}
        {...props}
      >
        {isLoading ? (
          <span className="flex items-center justify-center gap-2">
            <ImSpinner2 className="h-4 w-4 animate-spin" />
            {children}
          </span>
        ) : (
          <>
            {icon && iconPosition === "left" && (
              <span className={children ? "mr-2" : ""}>{icon}</span>
            )}
            {children}
            {icon && iconPosition === "right" && (
              <span className={children ? "ml-2" : ""}>{icon}</span>
            )}
          </>
        )}
      </button>
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
